import { PropsWithChildren, createContext, useContext, useMemo } from 'react'

type TrackFunction = (event: string, data?: Record<string, unknown>) => void

interface ITrackContextState {
  onTrack: TrackFunction
}

const TrackContext = createContext<ITrackContextState>({
  onTrack: () => undefined,
})

export const TrackProvider: React.FC<
  {
    onTrack: TrackFunction
  } & PropsWithChildren
> = ({ children, onTrack }) => {
  const value = useMemo(() => ({ onTrack }), [onTrack])
  return <TrackContext.Provider value={value}>{children}</TrackContext.Provider>
}

export const useTrack = () => {
  const { onTrack } = useContext(TrackContext)
  return onTrack
}
